import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import { SettingsProvider } from "@/lib/useSettings";
import { AdminAuthProvider, AdminProtected } from "@/lib/adminAuth";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import ServiceDetail from "@/pages/ServiceDetail";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Products from "@/pages/Products";
import Offers from "@/pages/Offers";
import ProductDetail from "@/pages/ProductDetail";
import NotFound from "@/pages/NotFound";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import WhatsAppFloating from "@/components/WhatsAppFloating";

// Admin
import AdminLogin from "@/pages/admin/Login";
import AdminLayout from "@/pages/admin/Layout";
import AdminDashboard from "@/pages/admin/Dashboard";
import AdminQuoteRequests from "@/pages/admin/QuoteRequests";
import ProductsAdmin from "@/pages/admin/ProductsAdmin";
import CategoriesAdmin from "@/pages/admin/CategoriesAdmin";
import ServicesAdmin from "@/pages/admin/ServicesAdmin";
import ProjectsAdmin from "@/pages/admin/ProjectsAdmin";
import TestimonialsAdmin from "@/pages/admin/TestimonialsAdmin";
import AdminSettings from "@/pages/admin/SettingsAdmin";
import BackupsAdmin from "@/pages/admin/BackupsAdmin";

function ScrollToTop() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return null;
}

// Public site shell (nav + footer + whatsapp)
const PublicShell = ({ children }) => (
  <>
    <Navbar />
    <main>{children}</main>
    <Footer />
    <WhatsAppFloating />
  </>
);

function App() {
  return (
    <div className="App font-body" dir="rtl" lang="ar">
      <BrowserRouter>
        <AdminAuthProvider>
          <SettingsProvider>
            <Routes>
              {/* Public site */}
              <Route path="/" element={<PublicShell><ScrollToTop /><Home /></PublicShell>} />
              <Route path="/services" element={<PublicShell><ScrollToTop /><Services /></PublicShell>} />
              <Route path="/services/:slug" element={<PublicShell><ScrollToTop /><ServiceDetail /></PublicShell>} />
              <Route path="/products" element={<PublicShell><ScrollToTop /><Products /></PublicShell>} />
              <Route path="/offers" element={<PublicShell><ScrollToTop /><Offers /></PublicShell>} />
              <Route path="/products/:slug" element={<PublicShell><ScrollToTop /><ProductDetail /></PublicShell>} />
              <Route path="/about" element={<PublicShell><ScrollToTop /><About /></PublicShell>} />
              <Route path="/contact" element={<PublicShell><ScrollToTop /><Contact /></PublicShell>} />

              {/* Admin */}
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route
                path="/admin"
                element={
                  <AdminProtected>
                    <AdminLayout />
                  </AdminProtected>
                }
              >
                <Route index element={<AdminDashboard />} />
                <Route path="quote-requests" element={<AdminQuoteRequests />} />
                <Route path="products" element={<ProductsAdmin />} />
                <Route path="categories" element={<CategoriesAdmin />} />
                <Route path="services" element={<ServicesAdmin />} />
                <Route path="projects" element={<ProjectsAdmin />} />
                <Route path="testimonials" element={<TestimonialsAdmin />} />
                <Route path="settings" element={<AdminSettings />} />
                <Route path="backups" element={<BackupsAdmin />} />
              </Route>

              <Route path="*" element={<PublicShell><NotFound /></PublicShell>} />
            </Routes>
            <Toaster position="top-center" richColors dir="rtl" offset={80} toastOptions={{ style: { fontFamily: "'Cairo', sans-serif", fontSize: "0.95rem", fontWeight: 600 } }} />
          </SettingsProvider>
        </AdminAuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
